import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import RenderComponent from '@/modules/DynamicRenderPage';
import { loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'pages/web/NotInUseVehicles');
const config = loadPageConfig();
const lazyImport = (path) => lazy(() => import(`@/${path}`));

const Content = lazyImport(config.vehicleNotInUse[1].name);
const TopActions = config.vehicleNotInUse[0].children && lazy(() => import(`${config.vehicleNotInUse[0].children.name}`));
const Title = lazy(() => import(`globalcomponents/Title`));

const NotInUseVehicles = ({ fetchNotInUseVehicles, history, i18n, theme, ...parentProps }) => {
  const [pagination, setPagination] = useState(false);
  const commonParentProps = { history, i18n, Styled, theme };

  useEffect(() => {
    fetchNotInUseVehicles({
      apiId: 'fetchNotInUseVehicles',
      data: 'INSHOP',
    });
  }, [fetchNotInUseVehicles]);

  return (
    <>
      <RenderComponent
        {...config.vehicleNotInUse[0]}
        parentProps={{ ...parentProps, pagination, setPagination }}
        commonParentProps={commonParentProps}
        component={Title}
        childComponent={TopActions}
        header="dashboard.notInUseVehicles.pageHeading.INSHOP"
      />
      <RenderComponent
        {...config.vehicleNotInUse[1]}
        parentProps={{ ...parentProps, pagination, setPagination }}
        commonParentProps={commonParentProps}
        component={Content}
      />
    </>
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  notInUseVehicles: state.notInUseVehicles,
});

const mapDispatch = (dispatch) => ({
  fetchNotInUseVehicles: (data) => dispatch.notInUseVehicles.fetchData(data),
  filterSuccess: (data) => dispatch.notInUseVehicles.filterSuccess(data),
});

NotInUseVehicles.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  fetchNotInUseVehicles: PropTypes.func.isRequired,
  notInUseVehicles: PropTypes.array.isRequired,
  i18n: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default connect(mapState, mapDispatch)(NotInUseVehicles);
